export const environment = {
  production: false,
  apiUrl: 'https://uat.mpr.upda.co.in:3016'
};
